import React from "react";
import "./footer.css";
import { FiInstagram } from "react-icons/fi";
import { BsLinkedin, BsGithub } from "react-icons/bs";

const socialLinks = [
  { icon: <BsGithub />, href: "https://github.com/KushtrimShabani", label: "GitHub" },
  { icon: <BsLinkedin />, href: "https://www.linkedin.com/in/kushtrimshabani/", label: "LinkedIn" },
  { icon: <FiInstagram />, href: "https://www.instagram.com/_kushtrimshabani/", label: "Instagram" },
];

const Footer = () => {
  return (
    <footer className="footer">
      {/* Pixel art city skyline */}
      <div className="footer__skyline" aria-hidden="true">
        <div className="footer__skyline-inner" />
      </div>

      <div className="container footer__inner">
        <span className="footer__name">Kushtrim Shabani</span>

        <div className="footer__socials">
          {socialLinks.map((item) => (
            <a
              key={item.label}
              href={item.href}
              target="_blank"
              rel="noreferrer"
              aria-label={item.label}
              className="footer__social-link"
            >
              {item.icon}
            </a>
          ))}
        </div>

        <small className="footer__copy pixel-text">
          &#9670; {new Date().getFullYear()} &#9670;
        </small>
      </div>
    </footer>
  );
};

export default Footer;
